import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import FigureCard from '@/components/feature/FigureCard';
import { figures } from '@/mocks/figures';

export default function FeaturedFigures() {
  const featured = figures.slice(0, 4);

  return (
    <section className="w-full border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-content px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          eyebrow="档案人物库"
          title="本期重点梳理的四位人物"
          description="每个人的档案都按时间顺序排列，包含公开履历、作品署名与涉及的事件条目。条目下方会标注材料来源类型，方便你自行核对。"
          action={
            <Link
              to="/figures"
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-foreground-300 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-500 hover:text-primary-800"
            >
              浏览全部 128 位
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          }
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {featured.map((figure) => (
            <FigureCard key={figure.id} figure={figure} />
          ))}
        </div>
      </div>
    </section>
  );
}